import { Injectable } from '@angular/core';
import { CHttp } from '../../core/services/chttp.service';
import { config } from '../../app.config';

@Injectable()
export class QuarterliesService {
  constructor(private http: CHttp) {}

  public getQuarterlies(data?: any) {
    return this.http.get(config.api_url + 'quarterlies', {
      params: data
    });
  }

  public getQuarterliesId(id: string) {
    return this.http.get(config.api_url + 'quarterlies/' + id);
  }

  public getQuarterliesStatuses() {
    return this.http.get(config.api_url + 'quarterlies/statuses');
  }

  public updateQuarterlies(data: any) {
    return this.http.put(`${config.api_url}quarterlies/${data.id}`, data);
  }

  public deleteQuarterlies(id: string) {
    return this.http.delete(`${config.api_url}quarterlies/` + id);
  }

  public terminateFreeSubscription(id: string) {
    return this.http.post(`${config.api_url}quarterlies/subscriptions/${id}/terminate`);
  }

  public addSubscription(id: string, data: any) {
    return this.http.post(`${config.api_url}quarterlies/subscriptions/${id}/system`, data);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/quarterlies/services/quarterlies.service.ts